class Instance {
    constructor(
        id,
        canBeEmbedded,
        childrenOverflow,
        currentPageId,
        fileName,
        hasRoundedCorner,
        interactivePages,
        itemType,
        naturalOrder,
        pages,
        position,
        publicWebUrl,
        referenceData,
        thumbnailSize,
        thumbnailUrl,
        transform
    ) {
        this.id = id;
        this.canBeEmbedded = canBeEmbedded;
        this.childrenOverflow = childrenOverflow;
        this.currentPageId = currentPageId;
        this.fileName = fileName;
        this.hasRoundedCorner = hasRoundedCorner;
        this.interactivePages = interactivePages;
        this.itemType = itemType;
        this.naturalOrder = naturalOrder;
        this.pages = pages;
        this.position = position;
        this.publicWebUrl = publicWebUrl;
        this.referenceData = referenceData;
        this.thumbnailSize = thumbnailSize;
        this.thumbnailUrl = thumbnailUrl;
        this.transform = transform;
    }
}

export class Transform {
    constructor(
        x,
        y,
        width,
        height,
        relativeWidthToParent
    ) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.relativeWidthToParent = relativeWidthToParent;
    }
}

export class ReferenceData {
    constructor(
        relativePath,
        typeId,
        relativeOrigin
    ) {
        this.relativePath = relativePath;
        this.typeId = typeId;
        this.relativeOrigin = relativeOrigin;

    }
}

export class InstanceBuilder {

    setId(id) {
        this.id = id;
        return this
    }
    setCanBeEmbedded(canBeEmbedded) {
        this.canBeEmbedded = canBeEmbedded;
        return this
    }
    setChildrenOverflow(childrenOverflow) {
        this.childrenOverflow = childrenOverflow;
        return this
    }
    setCurrentPageId(currentPageId) {
        this.currentPageId = currentPageId;
        return this
    }
    setfileName(fileName) {
        this.fileName = fileName;
        return this
    }
    setHasRoundedCorner(hasRoundedCorner) {
        this.hasRoundedCorner = hasRoundedCorner;
        return this
    }
    setInteractivePages(interactivePages) {
        this.interactivePages = interactivePages;
        return this
    }
    setItemType(itemType) {
        this.itemType = itemType;
        return this
    }
    setNaturalOrder(naturalOrder) {
        this.naturalOrder = naturalOrder;
        return this
    }
    setPages(pages) {
        this.pages = pages;
        return this
    }
    setPosition(position) {
        this.position = position;
        return this
    }
    setpublicWebUrl(publicWebUrl) {
        this.publicWebUrl = publicWebUrl;
        return this
    }
    setReferenceData(referenceData) {
        this.referenceData = referenceData;
        return this
    }
    setThumbnailSize(thumbnailSize) {
        this.thumbnailSize = thumbnailSize;
        return this
    }
    setThumbnailUrl(thumbnailUrl) {
        this.thumbnailUrl = thumbnailUrl;
        return this
    }
    setTransform(transform) {
        this.transform = transform;
        return this
    }

    build() {
        return new Instance(
            this.id,
            this.canBeEmbedded,
            this.childrenOverflow,
            this.currentPageId,
            this.fileName,
            this.hasRoundedCorner,
            this.interactivePages,
            this.itemType,
            this.naturalOrder,
            this.pages,
            this.position,
            this.publicWebUrl,
            this.referenceData,
            this.thumbnailSize,
            this.thumbnailUrl,
            this.transform
        );
    }

}